import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Text, Tooltip } from '@jisr-hr/design-system'
import stoc from 'string-to-color'
import { FeaturedIcon, Typography } from '@jisr-hr/ds'
import i18n from 'translations/i18n'
import { LazyAvatar } from 'components/global/atoms'
import EmployeeProfile from '../EmployeeProfile'

const AutomatedAvatar = ({ name, jobTitle, code, avatar }) => {
  if (!name) {
    return (
      <Flex
        itemsCenter
        style={{ gap: 12 }}
      >
        <Tooltip
          title={i18n.t('created_by_automation')}
          placement="top"
        >
          <div>
            <FeaturedIcon
              iconName="lightning-01"
              colorType="primary"
              size="md"
            />
          </div>
        </Tooltip>
        <Typography
          variant="body-new-medium"
          text={i18n.t('automated')}
        />
      </Flex>
    )
  }
  let additionalInfo = ''
  if (jobTitle) additionalInfo = jobTitle
  if (jobTitle && code) additionalInfo += ' - '
  if (code) additionalInfo += code

  return (
    <Flex
      itemsCenter
      style={{ gap: 12 }}
    >
      <div style={{ position: 'relative' }}>
        <LazyAvatar
          containerStyle={{ width: 34, height: 34 }}
          style={{
            width: 34,
            height: 34,
            backgroundColor: stoc(name),
          }}
          src={avatar}
          alt={name}
        />
        <Tooltip
          title={i18n.t('created_by_automation')}
          placement="top"
        >
          <div style={{ position: 'absolute', insetInlineEnd: -4, bottom: -4 }}>
            <FeaturedIcon
              iconName="lightning-01"
              colorType="primary"
              size="xs"
              style={{ width: 12, height: 12 }}
            />
          </div>
        </Tooltip>
      </div>
      <div>
        <Typography
          variant="body-new-regular"
          text={name}
        />
        <Typography
          variant="caption"
          textColor="onNeutralLight"
          text={additionalInfo}
        />
      </div>
    </Flex>
  )
}

const ProfileAndTime = ({
  name,
  jobTitle,
  code,
  avatar,
  date,
  time,
  onProfileClick,
  is_created_by_automation,
}) => (
  <Flex
    justifyBetween
    itemsCenter
  >
    {is_created_by_automation ? (
      <AutomatedAvatar
        name={name}
        jobTitle={jobTitle}
        code={code}
        avatar={avatar || ''}
      />
    ) : (
      <EmployeeProfile
        name={name}
        jobTitle={jobTitle}
        code={code}
        avatar={avatar || ''}
        weight="medium"
        avatarStyle={{ backgroundColor: stoc(name) }}
        onProfileClick={onProfileClick}
      />
    )}

    <Text
      typography="paragraph14"
      color="rgba(6, 6, 43, 0.4)"
      as="div"
      align="end"
    >
      {date || ''} <br />
      {time}
    </Text>
  </Flex>
)

ProfileAndTime.propTypes = {
  code: PropTypes.number,
  name: PropTypes.string,
  jobTitle: PropTypes.string,
  avatar: PropTypes.string,
  time: PropTypes.string,
  is_created_by_automation: PropTypes.bool,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  onProfileClick: PropTypes.func,
}

export default ProfileAndTime
